module.exports = __webpack_public_path__ + "media/images/1200/gym-2de8a3779b92fdaa8ee6d7e088ca242b.webp";